<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.messageConfig.list") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/integrationMessageConfig"><span>{{$t('tlt.messageConfig')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <mmf-button type="add"
                                show-name
                                v-has-permission="'scope.integrationMessageConfig.addEdit'"
                                v-bind:class="'btn btn-outline-primary'"
                                v-on:click="MMFNew('integrationMessageConfig')">
                    </mmf-button>
                    <!-- <button class="btn btn-outline-primary" v-on:click="MMFNew('integrationMessageConfig')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button> -->
                </div>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form>
                                <mmf-filter entity="integrationMessageConfig" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="integrationMessageConfigsResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="integrationMessageConfig"
                                        inline-actions-disabled singleChoice>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/adm/IntegrationMessageConfig";
import MmfFilter from "@/components/MmfFilter";
import MmfTable from "@/components/MmfTable";
import MmfButton from "@/components/MmfButton";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'integrationMessageConfig/getField',
    mutationType: 'integrationMessageConfig/updateField',
  });

export default {
  name: "integrationMessageConfigList",
  data () {
    return {
      
    }
  },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.integrationMessageConfig.rows,
            checkedItems: state => state.integrationMessageConfig.checkedItems,
            tableColumns: gridFields,
            messageType: state => state.integrationMessageConfig.messageType
        })
  },
  methods: {
    toggleAll(checked) {
        if(!checked){
            this.$store.commit( "integrationMessageConfig/checkedItems", [] );
            return;
        }

        var auxVector = []
        for (let i in this.$store.state.integrationMessageConfig.rows)
            auxVector.push(this.$store.state.integrationMessageConfig.rows[i].id)

        this.$store.commit( "integrationMessageConfig/checkedItems", auxVector );
    },
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  },
  mounted(){
      this.$store.dispatch('integrationMessageConfig/loadMessageType');
  },
  components: {
    MmfFilter,
    MmfTable,
    MmfButton
  }
};
</script>
